<!-- pkgs: {{ shoppingCartService.$packages | json }}<br> -->

<mat-table [dataSource]="dataSource" multiTemplateDataRows matSort [@.disabled]="false" [trackBy]="trackByPackageId">

  <ng-container matColumnDef="id">
    <mat-header-cell *matHeaderCellDef class="w-100">{{ 'PACK_LIST.TABLE_HEADER_PACKAGE_ID' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let package" class="w-100" [innerHTML]="package.id | highlight:(filterService.filterQuery$ | async)"></mat-cell>
  </ng-container>

  <ng-container matColumnDef="warehouse">
    <mat-header-cell *matHeaderCellDef class="w-100">{{ 'PACK_LIST.TABLE_HEADER_WAREHOUSE' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let package" class="w-100" [innerHTML]="package.warehouseCode | highlight:(filterService.filterQuery$ | async)"></mat-cell>
  </ng-container>

  <ng-container matColumnDef="certificate">
    <mat-header-cell *matHeaderCellDef class="w-100">{{ 'PACK_LIST.TABLE_HEADER_CERT' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let package" class="w-100" [innerHTML]="(package.certificate && 'CERTIFICATE.' + package.certificate) | translate | highlight:(filterService.filterQuery$ | async)"></mat-cell>
  </ng-container>

  <ng-container matColumnDef="landed">
    <mat-header-cell *matHeaderCellDef class="w-100">{{ 'PACK_LIST.TABLE_HEADER_LANDED' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let package" class="w-100">
      <ng-container *ngIf="package.landed">{{ package.landed | date:'shortDate':'':locale }}</ng-container>
      <ng-container *ngIf="!package.landed">-</ng-container>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="shippingMark">
    <mat-header-cell *matHeaderCellDef class="w-100">{{ 'PACK_LIST.TABLE_HEADER_SHIPPINGMARK' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let package" class="w-100" [innerHTML]="package.shippingMark | highlight:(filterService.filterQuery$ | async)"></mat-cell>
  </ng-container>

  <ng-container matColumnDef="volume">
    <mat-header-cell *matHeaderCellDef class="w-50">{{ 'PACK_LIST.TABLE_HEADER_VOLUME' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let package" class="w-50">{{package.volume}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="weight">
    <mat-header-cell *matHeaderCellDef class="w-50">{{ 'PACK_LIST.TABLE_HEADER_WEIGHT' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let package" class="w-50">{{package.weight}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="pcs">
    <mat-header-cell *matHeaderCellDef class="w-50">{{ 'PACK_LIST.TABLE_HEADER_TOTAL_NUM_PIECES' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let package" class="w-50">{{package.pcs}}</mat-cell>
  </ng-container>

  <ng-container *ngFor="let length of packetLengths;">
    <ng-container matColumnDef="length-{{length}}">
      <mat-header-cell *matHeaderCellDef class="w-40" [innerHTML]="length | highlight:(filterService.filterQuery$ | async)"></mat-header-cell>
      <mat-cell *matCellDef="let package" class="w-40">
        {{ package.lengths ? package.lengths['length-' + length] : '??' }}
      </mat-cell>
    </ng-container>
  </ng-container>

  <ng-container matColumnDef="pcsTitle">
    <mat-cell *matCellDef="let package">{{ 'PACK_LIST.TABLE_SUMMARY_PCS' | translate }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="summary">
    <mat-cell *matCellDef="let package">{{package.summary}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="expansion">
    <!-- <mat-cell *matCellDef="let package" [attr.colspan]="desktop ? displayedColumns.length : displayedColumnsDefaults.length" [@detailExpand]="expandedPackages[package.id] ? 'expanded' : 'collapsed'"> -->
    <mat-cell *matCellDef="let package" [attr.colspan]="displayedColumns.length">
      <section class="fields">
        <!-- price input -->
        <div class="block price" *ngIf="internalUser">
          <span>{{ 'PACK_LIST.LABEL_ENTER_PRICE' | translate }}</span>
          <mat-form-field appearance="legacy">
            <!-- <input matInput [(ngModel)]="package.selectedPrice" type="number" name="{{ package.id }}-price" floatLabel="never"> -->
            <input matInput [value]="package.payload.selectedPrice" (change)="shoppingCartService.setPriceAndUpdate(package.payload, $event.target.value)" type="number" name="{{ package.id }}-price" floatLabel="never" required [min]="50" [max]="2000" step="1">
            <span matSuffix>{{ currency }}</span>
            <mat-hint *ngIf="!validPrice(package.payload.selectedPrice)">{{ 'CART.TEXT_VALIDATION_PRICE_RANGE' | translate:{min:minPrice, max:maxPrice} }}</mat-hint>
          </mat-form-field>
        </div>
        <!-- certificate input -->
        <div class="block" *ngIf="!package.certificate">
          <span>{{ 'FILTER.TITLE_CERTIFICATES' | translate }}</span>
          <mat-radio-group [value]="package.payload.selectedCert" (change)="shoppingCartService.setCertAndUpdate(package.payload, $event.value)" name="{{ package.id }}-certificate" required>
            <mat-radio-button *ngFor="let cert of codesApiService.certificates$ | async" [value]="cert.value" class="plain">
              {{ 'CERTIFICATE.' + cert.value | translate }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </section>
      <section class="actions">
        <button type="button" mat-button (click)="onDeselect(package)">{{ 'PACK_LIST.ACTION_DESELECT' | translate }}</button>
      </section>
    </mat-cell>
  </ng-container>

  <!--
  <mat-header-row *matHeaderRowDef="desktop ? displayedColumns : displayedColumnsDefaults" [class.desktop]="desktop">
  </mat-header-row>

  <mat-row *matRowDef="let row; columns: desktop ? displayedColumns : displayedColumnsDefaults;"
    (click)="onSelectedRow(row)" class="primary" [class.unavailable]="!row.hasLanded"
    [class.selected]="isSelected(row.payload)" [class.desktop]="desktop" [class.disabled]="!row.hasLanded">
  </mat-row> -->

  <mat-header-row *matHeaderRowDef="displayedColumns" [class.desktop]="true">
  </mat-header-row>

  <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onSelectedRow(row)" class="primary" [class.unavailable]="!row.hasLanded" [class.selected]="isSelected(row.payload)" [class.desktop]="true" [class.disabled]="!row.hasLanded">
  </mat-row>
  <ng-container *ngIf="cart">
    <mat-row *matRowDef="let row; columns: ['expansion']" class="expansion"></mat-row>
  </ng-container>

</mat-table>
